import { render, staticRenderFns } from "./schwartz.vue?vue&type=template&id=253a62ba"
import script from "./schwartz.vue?vue&type=script&lang=js"
export * from "./schwartz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports